import { useState, useRef, useEffect } from "react";
import { FiMoon, FiSun, FiUser, FiSettings, FiBell, FiLogOut, FiAlignLeft, FiArrowRight } from "react-icons/fi";


const getRoleName = (role) => {
  switch (Number(role)) {
    case 1:
      return "SUPER ADMIN";
    case 2:
      return "ADMIN";
    default:
      return "USER";
  }
};

const formatName = (name) => {
  if (!name) return "User";

  return name
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const Header = ({
  isMobileMenuOpen,
  isMiniMenu,
  darkMode,
  toggleSidebar,
  toggleMobileMenu,
  closeMobileMenu,
  toggleDarkMode
}) => {

  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="nxl-header">
      <div className="header-wrapper">

        {/* HEADER LEFT */}
        <div className="header-left d-flex align-items-center gap-4">

          {/* MOBILE MENU */}
          <a onClick={toggleMobileMenu} className="nxl-head-mobile-toggler" id="mobile-collapse">
            <div className="hamburger hamburger--arrowturn">
              <div className="hamburger-box">
                <div className="hamburger-inner"></div>
              </div>
            </div>
          </a>

          {isMobileMenuOpen && (
            <div className="nxl-menu-overlay" onClick={closeMobileMenu}></div>
          )}

          {/* SIDEBAR TOGGLE */}
          <div className="nxl-navigation-toggle">
            <a href="#!" onClick={toggleSidebar}>
              {isMiniMenu ? <FiArrowRight size={18} /> : <FiAlignLeft size={18} />}
            </a>
          </div>

        </div>

        {/* HEADER RIGHT */}
        <div className="header-right ms-auto">
          <div className="d-flex align-items-center">

            {/* SEARCH */}
            {/* <div className="dropdown nxl-h-item nxl-header-search">
              <a href="#!" className="nxl-head-link me-0" data-bs-toggle="dropdown">
                <FiSearch size={26}/>
              </a>

              <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-search-dropdown">

                <div className="input-group search-form">
                  <span className="input-group-text">
                    <FiSearch size={26}/>
                  </span>

                  <input
                    type="text"
                    className="form-control search-input-field"
                    placeholder="Search...."
                  />

                  <span className="input-group-text">
                    <button type="button" className="btn-close"></button>
                  </span>
                </div>

              </div>
            </div> */}

            {/* DARK MODE */}
            <div className="nxl-h-item dark-light-theme">
              <a onClick={toggleDarkMode} className="nxl-head-link me-0">
                {darkMode ? <FiSun size={26} /> : <FiMoon size={26} />}
              </a>
            </div>

            {/* USER PROFILE */}
            <div ref={dropdownRef} className="dropdown nxl-h-item ms-3">
              <button
                type="button"
                className="border-0 bg-transparent p-0"
                onClick={() => setIsProfileOpen((prev) => !prev)}
              >
                <img
                  src="/images/avatar/userprofile.jpg"
                  alt="user"
                  className="img-fluid user-avtar me-0"
                />
              </button>

              {isProfileOpen && (
                <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown show">

                  <div className="dropdown-header">
                    <div className="d-flex align-items-center">

                      <img
                        src="/images/avatar/userprofile.jpg"
                        alt="user"
                        className="img-fluid user-avtar"
                      />

                      <div>
                        <h6 className="text-dark mb-0">
                          {formatName(user?.name)}
                          <span className="badge bg-soft-success text-success ms-1">
                            {getRoleName(user?.role)}
                          </span>
                        </h6>
                        <span className="fs-12 fw-medium text-muted">
                          {user?.email || ""}
                        </span>
                      </div>

                    </div>
                  </div>

                  {/* <div className="dropdown-divider"></div> */}

                  <a href="/profile" className="dropdown-item">
                    <FiUser style={{ marginRight: 8 }} />
                    <span>Profile Details</span>
                  </a>

                  {/* <a href="#!" className="dropdown-item">
                  <FiSettings style={{ marginRight: 8 }} />
                  <span>Account Settings</span>
                </a>
                <a href="#!" className="dropdown-item">
                  <FiBell style={{ marginRight: 8 }} />
                  <span>Notifications</span>
                </a> */}

                  <div className="dropdown-divider"></div>

                  <a href="/login" className="dropdown-item">
                    <FiLogOut style={{ marginRight: 8 }} />
                    <span>Logout</span>
                  </a>

                </div>
              )}
            </div>

          </div>
        </div>

      </div>
    </header>
  );
};

export default Header;